export const REPORTING_PERIOD = '1 April 2026 and 30 September 2026';
